import React, { useState, useEffect } from 'react';
//import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { 
//  Button, 
  Dialog, 
  // DialogActions,
  // DialogContent,
  // DialogContentText,
  // ListItemText, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  // MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  // TablePagination
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { IsNoU } from 'common/utils';

// URIs
//import serverURI from '../../../../../config/URI';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    row: {
        //height: '82px',
        display: 'flex',
        alignItems: 'center',
        '& > *': {
        margin: theme.spacing(1),
        },
    },
    content: {
        marginTop: theme.spacing(2)
    },
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    registerListItemTitle: {
        marginLeft: theme.spacing(2),
        width: '100px',
    },
    registerListItemInput: {
        //marginLeft: theme.spacing(2),
        width: '240px',
        //height: '40px',
    },
    registerListItemFilePath: {
        //marginLeft: theme.spacing(2),
        width: '640px',
    },
    registerListItemUpload: {
        marginLeft: theme.spacing(2),
    },
    registerListItemTitle1: {
        marginLeft: theme.spacing(2),
        width: '100px',
    },
    registerListItemTitle2: {
        marginLeft: theme.spacing(4),
        width: '100px',
    },
    registerListItemDateGap: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewCampaign = (props) => {

    const classes = useStyles();

    const { 
        openDialog, 
        onClickCloseDialog,
        campaign,
        // advertiseName,
        // advertiseMovieURL,
        // advertiseMovie,
        // advertiseImageURL,
        // advertiseImage,
    } = props;

    const [campaignName, setCampaignName] = useState('');
    const [campaignTotalPlayTime, setCampaignTotalPlayTime] = useState(0);
    const [campaignTotalFileSize, setCampaignTotalFileSize] = useState(0);
    const [campaignAdvertises, setCampaignAdvertises] = useState([]);

    // const [rowsPerPage, setRowsPerPage] = useState(10);
    // const [page, setPage] = useState(0);

    useEffect(() => {
      if (!IsNoU(campaign)) {

        //console.log(campaign);

        if (!IsNoU(campaign.name)) {
          setCampaignName(campaign.name);
        }

        let newCampaignAdvertises = [];
        if (!IsNoU(campaign.defaults) && campaign.defaults.length > 0) {
          newCampaignAdvertises = newCampaignAdvertises.concat(campaign.defaults);
        }
        if (!IsNoU(campaign.normals) && campaign.normals.length > 0) {
          newCampaignAdvertises = newCampaignAdvertises.concat(campaign.normals);
        }
        if (!IsNoU(campaign.images) && campaign.images.length > 0) {
          newCampaignAdvertises = newCampaignAdvertises.concat(campaign.images);
        }

        //console.log(newCampaignAdvertises);

        let totalPlayTime = 0;
        let totalFileSize = 0;
        newCampaignAdvertises.map((advertise) => {
          if (!IsNoU(advertise.playtime))
            totalPlayTime += parseInt(advertise.playtime, 10);
          if (!IsNoU(advertise.filesize))
            totalFileSize += parseInt(advertise.filesize, 10);
        });

        setCampaignTotalPlayTime(totalPlayTime);
        setCampaignTotalFileSize(totalFileSize);

        setCampaignAdvertises(newCampaignAdvertises);
        //console.log(newCampaignAdvertises);
      }

    }, [campaign]); // empty-array means don't watch for any updates

    return (
        <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h5" className={classes.title} color="inherit">
                캠패인 보기
              </Typography>
            </Toolbar>
          </AppBar>

          <List>
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              {campaignName}
            </Typography>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                전체 재생 시간
              </Typography>
              <TextField
                className={classes.registerListItemInput}
                id="outlined-basic1"
                //variant="outlined"
                value={Math.floor(campaignTotalPlayTime/60) + '분' + Math.floor(campaignTotalPlayTime%60) + '초'}
                disabled={true}
                margin="dense" />

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                전체 용량
              </Typography>
              <TextField
                className={classes.registerListItemInput}
                id="outlined-basic2"
                //variant="outlined"
                value={Math.floor(campaignTotalFileSize/(1024*1024)) + 'MB'}
                disabled={true}
                margin="dense" />
            </ListItem>
            <Divider />
            <ListItem>
              <PerfectScrollbar>
                <div className={classes.inner}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>번호</TableCell>
                        <TableCell>광고명</TableCell>
                        <TableCell>탬플릿</TableCell>
                        <TableCell>광고유형</TableCell>
                        <TableCell>재생시간</TableCell>
                        <TableCell>파일용량</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {campaignAdvertises.map((advertise, index) => (
                        <TableRow
                          className={classes.tableRow}
                          hover
                          key={advertise.id}
                        >
                          <TableCell>{index}</TableCell>
                          <TableCell>
                            <div className={classes.nameContainer}>
                              <Typography variant="body1">{advertise.name}</Typography>
                            </div>
                          </TableCell>
                          <TableCell>{advertise.template}</TableCell>
                          <TableCell>{advertise.type === 'free' ? '무료' : '유료'}</TableCell>
                          <TableCell>{Math.floor(advertise.playtime/60) + '분' + Math.floor(advertise.playtime%60) + '초'}</TableCell>
                          <TableCell>{Math.floor(advertise.filesize/(1024*1024)) + 'MB'}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </PerfectScrollbar>
            </ListItem>
          </List>
      </Dialog>
    )
}

export default PreviewCampaign;